import Vue from "vue";
import Vuex from "vuex";
import VueCookies from "vue-cookies";
import Vue2Editor from "vue2-editor";
import VueTimepicker from "vue2-timepicker";
import Toasted from "vue-toasted";
import moment from "vue-moment";
import * as VueGoogleMaps from "vue2-google-maps";
import Progress from "vue-multiple-progress";

import ckeditorConfig from "./ckeditor-config"; // 👈 custom config

// Install plugins
Vue.use(Vuex);
Vue.use(VueCookies);

// Pass CKEditor config to Vue2Editor
Vue.use(Vue2Editor, {
  config: ckeditorConfig,
});

Vue.use(VueTimepicker);
Vue.use(Toasted, {
  position: "bottom-right",
  duration: 3000,
  keepOnHover: true,
});
Vue.use(moment);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAoICXqGkchKOAwsgZePC1D36JQmhcybHA",
    libraries: "places",
  },
});

// Global component
Vue.component("VmProgress", Progress);
